import { render, staticRenderFns } from "./AttsLesson.vue?vue&type=template&id=d472c1e8&"
import script from "./AttsLesson.vue?vue&type=script&lang=js&"
export * from "./AttsLesson.vue?vue&type=script&lang=js&"
import style0 from "./AttsLesson.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports